import React from 'react'
import Card from '@Reusable/Card/Card'
import { Tabs } from 'antd'

import LeadScanQuestions from './LeadScanQuestions'
import SponsorLeadTable from './SponsorLeadTable'

export default function Leads() {
  const [activeTab, setActiveTab] = React.useState<string>('outbound')

  return (
    <Card title={'Scans'} testId={'scans'}>
      <Tabs activeKey={activeTab} onChange={setActiveTab}>
        <Tabs.TabPane tab={'Outbound scans'} key={'outbound'}>
          <SponsorLeadTable scanningDirection={'outbound'} />
        </Tabs.TabPane>
        <Tabs.TabPane tab={'Inbound scans'} key={'inbound'}>
          <SponsorLeadTable scanningDirection={'inbound'} />
        </Tabs.TabPane>
        <Tabs.TabPane tab={'Scan questions'} key={'questions'}>
          <LeadScanQuestions />
        </Tabs.TabPane>
      </Tabs>
    </Card>
  )
}

Leads.routeConfig = {
  path: '/scans'
}
